'use client'
import Link from "next/link"
import { Fragment, LinkHTMLAttributes, ReactNode, useMemo } from "react"
import { useCmsStore } from "../AppHooks"
import { useSearchParams } from "next/navigation"

export function LinkWrapper(props: { url: string, children: ReactNode } & LinkHTMLAttributes<HTMLAnchorElement>) {
    const { className, url, children, ...otherProps } = props
    const { locale } = useCmsStore()!
    const searchParams = useSearchParams()
    const finalUrl = useMemo(() => {
        if (!url) return ''
        const params = new URLSearchParams(searchParams?.toString())
        params.delete('cocktailId')
        params.delete('noResult')
        const base = `/${locale}${url.startsWith('/') ? url : `/${url}`}`
        const query = params.toString()
        return query ? `${base}${base.includes('?') ? '&' : '?'}${query}` : base
    }, [url, locale, searchParams])
    if (finalUrl && children) {
        if (/^https?:\/\//.test(url)) {
            return <a href={url} target="_blank" rel="noopener noreferrer" {...otherProps}>{children}</a>
        }
        return <Link href={finalUrl} {...otherProps}>{children}</Link>
    }
    return <Fragment>
        {children}
    </Fragment>
}